
import { useState } from "react";
import { Question } from "@/types/quiz";
import { useQuizCompletion } from "../use-quiz-completion";

export const useQuizScore = () => {
  const [score, setScore] = useState(0);
  const { handleQuizComplete } = useQuizCompletion();

  const handleScoreUpdate = (
    isCorrect: boolean,
    currentScore: number
  ): number => {
    if (isCorrect) {
      const newScore = currentScore + 1;
      setScore(newScore);
      return newScore;
    }
    return currentScore;
  };

  const completeQuiz = async (
    hasAttempted: boolean,
    questions: Question[],
    currentScore: number,
    selectedAnswer: string | null,
    currentQuestionIndex: number
  ) => {
    // Calculate the final score including the last answer if correct
    const lastQuestionCorrect = selectedAnswer === questions[currentQuestionIndex]?.correct_answer;
    const finalScore = Math.min(currentScore + (lastQuestionCorrect ? 1 : 0), questions.length);
    
    console.log(`Completing quiz with final score: ${finalScore}/${questions.length}`);
    
    const completionScore = await handleQuizComplete(
      hasAttempted,
      questions,
      finalScore,
      selectedAnswer,
      currentQuestionIndex
    );
    
    if (completionScore !== null) {
      setScore(finalScore);
    }
    return completionScore;
  };

  return {
    score,
    handleScoreUpdate,
    completeQuiz,
  };
};
